module.exports = __webpack_public_path__ + "static/cot2balcony-6f3503309989ecaa933f6e03aad491d7.jpg";